<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title"><a id="page_vii">C<span class="smallcaps">ONTENTS</span></a></h1><a id="page_vii">
</a><p class="toc-fm"><a id="page_vii"></a><a href="#/006_Abbre#fm-1"><em>Abbreviations and Symbols</em></a></p>
<p class="toc-fm"><a href="#/007_Foreword#fm-2"><em>Editors’ Foreword</em></a></p>
<p class="toc-fm"><a href="#/008_Authors#fm-3"><em>Author’s Preface</em></a></p>
<p class="toc-fm"><a href="#/009_Introduction#fm-4"><em>Introduction</em></a></p>
<p class="toc-chap1"><a href="#/010_Chapter01#ch-1"><strong>1 SAMUEL</strong></a></p>
<p class="toc-chap"><a href="#/010_Chapter01#ch-1"><span class="toc"><em>Chapter 1</em></span> <em>The Overall Shape and Scope of 1–2 Samuel</em></a></p>
<p class="toc-chap"><span href="#/011_Chapter02#ch-2" title="Link target outside of Sample"><span class="toc"><em>Chapter 2</em></span> <em>The Arrival of Samuel on the National Scene (1 Sam 1–3)</em></span></p>
<p class="toc-chap"><span href="#/012_Chapter03#ch-3" title="Link target outside of Sample"><span class="toc"><em>Chapter 3</em></span> <em>The Departure of the Ark from the National Scene (1 Sam 4–6)</em></span></p>
<p class="toc-chap"><span href="#/013_Chapter04#ch-4" title="Link target outside of Sample"><span class="toc"><em>Chapter 4</em></span> <em>The Emergence of the Monarchy: The Arrival of Saul and the New Institution of Monarchy (1 Sam 7–12)</em></span></p>
<p class="toc-chap"><span href="#/014_Chapter05#ch-5" title="Link target outside of Sample"><span class="toc"><em>Chapter 5</em></span> <em>The Emergence of the Monarchy: The Dismissal of Saul and the Beginning of David’s Arrival (1 Sam 13:1–16:13)</em></span></p>
<p class="toc-chap"><span href="#/015_Chapter06#ch-6" title="Link target outside of Sample"><span class="toc"><em>Chapter 6</em></span> <em>David’s Emergence in Israel (1 Sam 16:14–18:16)</em></span></p>
<p class="toc-chap"><span href="#/016_Chapter07#ch-7" title="Link target outside of Sample"><span class="toc"><em>Chapter 7</em></span> <em>Veiled Conflict at the Court (1 Sam 18:17–21:1)</em></span></p>
<p class="toc-chap"><span href="#/017_Chapter08#ch-8" title="Link target outside of Sample"><span class="toc"><em>Chapter 8</em></span> <em>Open Rupture between David and Saul (1 Sam 21:2–27:12)</em></span></p>
<p class="toc-chap"><a id="page_viii"></a><span href="#/018_Chapter09#ch-9" title="Link target outside of Sample"><span class="toc"><em>Chapter 9</em></span> <em>The Ultimate Failure of Saul (1 Sam 28–31)</em></span></p>
<p class="toc-chap"><span href="#/019_Chapter10#ch-10" title="Link target outside of Sample"><span class="toc"><em>Chapter 10</em></span> <em>Diachronic Dimension: From Past Texts to Present Text</em></span></p>
<p class="toc-bm"><span href="#/020_Glossary#bm-1" title="Link target outside of Sample"><em>Glossary</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005_Contents.vue?8d04743e